import { g as getWindow } from './getWindow-JtVpfBBJ.js';

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

export { getWindowScroll as g };
//# sourceMappingURL=getWindowScroll-E89-q1-1.js.map
